<template>
  <div
    :class="{
      'footer-menu-wrapper flex w-full flex-wrap lg:order-2': true,
    }"
  >
    <div
      :class="{
        'lg:mr-[2%]': true,
        'mb-10 w-2/4 md:mr-[2%] md:w-[28.5%] lg:w-[31%]': true,
      }"
    >
      <FooterColumn
        v-if="column1"
        v-bind="column1"
      />
    </div>
    <div
      :class="{
        'lg:mr-[2%]': true,
        'mb-10 w-2/4 md:mr-[2%] md:w-[24.5%] lg:w-[25%]': true,
      }"
    >
      <FooterColumn
        v-if="column2"
        v-bind="column2"
      />
    </div>
    <div
      :class="{
        'lg:mr-[2%]': true,
        'mb-10 w-2/4 md:mr-[2%] md:w-[22.5%] lg:w-[24%]': true,
      }"
    >
      <FooterColumn
        v-if="column3"
        v-bind="column3"
      />
    </div>
    <div
      :class="{
        'lg:mr-[2%]': true,
        'mb-10 mr-0 w-2/4 md:w-[18.5%] lg:w-[12%]': true,
      }"
    >
      <FooterColumn
        v-if="column4"
        v-bind="column4"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Footer } from '~/sanity/types';
import FooterColumn from './FooterColumn.vue';
defineProps<Footer>();
</script>

<style></style>
